import { useFormik } from 'formik'
import i18n from 'i18next'
import { Row } from 'reactstrap'
import * as Yup from 'yup'
import agency from '../../../../api/agency/hooks'
import BreadCrumb from '../../../../Components/Common/BreadCrumb'
import AdminLoader from '../../Components/AdminLoader/AdminLoader'
import AgencyOfficeForm from '../../Components/AgencyOfficeForm/AgencyOfficeForm'
import { officeAgencyFieldDescription } from '../../Components/AgencyOfficeForm/officeAgencyFieldDescription'
import UploadPhoto from '../../Components/UploadPhoto/UploadPhoto'
import { officeValidation } from '../../Office/validateRules'
import { DEFAULT_TRANSPARENCY } from '../../constants'
import { formatPhoneNumber } from '../../helpers'

const AgencyEdit = () => {
    const description = officeAgencyFieldDescription()

    const { data: agencyData = {}, isLoading } = agency.GetAgency.useQuery()
    const { mutate: updateAgency } = agency.UpdateAgency.useMutation()

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: !isLoading ? agencyData : {},
        validationSchema: Yup.object(officeValidation()),
        onSubmit: (values) => {
            delete values.qrCode

            const phoneNumber = formatPhoneNumber(values?.phoneNumber)
            const mobileNumber = formatPhoneNumber(values?.mobileNumber)

            updateAgency({
                ...values,
                mobileNumber: mobileNumber ?? '',
                phoneNumber: phoneNumber ?? '',
                watermarkTransparency: values.watermarkTransparency || DEFAULT_TRANSPARENCY,
                logo: values.logo ?? '',
            })
        },
    })

    return isLoading ? (
        <AdminLoader />
    ) : (
        <Row>
            <BreadCrumb title={`${i18n.t('page.edit')} ${formik?.values?.name}`} />
            <UploadPhoto
                formik={formik}
                photoField={'logo'}
                imageUrl={formik?.values?.logo}
                firstName={formik?.values?.name}
                headline={formik?.values?.name}
                permission={description.agencyLogo}
            />
            <AgencyOfficeForm formik={formik} cancelButtonUrl={'/admin/agency'} />
        </Row>
    )
}

export default AgencyEdit
